// API 설정 관리
export const API_CONFIG = {
    // 서버 설정
    servers: {
        internal: 'http://172.30.1.92:80',
        external: 'http://14.33.192.19:80',
        local: 'http://localhost:80',
        prod: 'https://twsyggspze.execute-api.ap-northeast-2.amazonaws.com/prod'
    },
    
    // 기본 설정
    default: {
        timeout: 10000,
        headers: {
            'Content-Type': 'application/json',
        }
    },
    
    // 연결 테스트 설정
    health: {
        endpoint: '/health',
        timeout: 3000
    }
};

// 환경별 API URL 결정
export const getApiUrl = () => {
    // 환경 변수로 직접 설정된 경우
    // if (process.env.REACT_APP_API_URL) {
    //     return process.env.REACT_APP_API_URL;
    // }
    
    // // 개발 환경에서는 로컬 서버 사용
    // if (process.env.NODE_ENV === 'development') {
    //     return API_CONFIG.servers.local;
    // }
    
    // 프로덕션 환경에서는 IP 기반 결정
    // return getApiUrlByIp();

    const hostname = window.location.hostname;
    
    // 내부망 IP 범위 확인
    const isInternalNetwork = () => {
        const ipParts = hostname.split('.').map(Number);
        
        // 172.16.0.0 ~ 172.31.255.255
        if (ipParts[0] === 172 && ipParts[1] >= 16 && ipParts[1] <= 31) {
            return true;
        }
        
        // 192.168.0.0 ~ 192.168.255.255
        if (ipParts[0] === 192 && ipParts[1] === 168) {
            return true;
        }
        
        // 10.0.0.0 ~ 10.255.255.255
        if (ipParts[0] === 10) {
            return true;
        }
        
        return false;
    };

    const isExternalNetwork = () => {
        const ipParts = hostname.split('.').map(Number);

        if (ipParts[0] === 14 && ipParts[1] == 33 && ipParts[2] == 192) {
            return true;
        }
        
        return false;
    };

    if (hostname === 'localhost' || hostname === '127.0.0.1') {
        return API_CONFIG.servers.local;
    }
    
    // return isInternalNetwork() 
    //     ? API_CONFIG.servers.internal 
    //     : API_CONFIG.servers.external;

    if (isInternalNetwork()) {
        return API_CONFIG.servers.internal;
    }

    if (isExternalNetwork()) {
        return API_CONFIG.servers.external;
    }

    return API_CONFIG.servers.prod;
};

// // IP 기반 API URL 결정
// export const getApiUrlByIp = () => {
//     const hostname = window.location.hostname;
    
//     // 내부망 IP 범위 확인
//     const isInternalNetwork = () => {
//         const ipParts = hostname.split('.').map(Number);
        
//         // 172.16.0.0 ~ 172.31.255.255
//         if (ipParts[0] === 172 && ipParts[1] >= 16 && ipParts[1] <= 31) {
//             return true;
//         }
        
//         // 192.168.0.0 ~ 192.168.255.255
//         if (ipParts[0] === 192 && ipParts[1] === 168) {
//             return true;
//         }
        
//         // 10.0.0.0 ~ 10.255.255.255
//         if (ipParts[0] === 10) {
//             return true;
//         }
        
//         return false;
//     };

//     if (hostname === 'localhost' || hostname === '127.0.0.1') {
//         return API_CONFIG.servers.local;
//     }
    
//     return isInternalNetwork() 
//         ? API_CONFIG.servers.internal 
//         : API_CONFIG.servers.external;
// };

// 현재 API URL 정보 출력
export const logApiInfo = () => {
    const currentUrl = getApiUrl();
    const hostname = window.location.hostname;
    
    console.log('=== API 설정 정보 ===');
    console.log('현재 호스트:', hostname);
    console.log('선택된 API URL:', currentUrl);
    console.log('환경:', process.env.NODE_ENV);
    console.log('환경 변수 API URL:', process.env.REACT_APP_API_URL || '설정되지 않음');
    console.log('========================');
}; 


